/**
 * Marks a browser session as synthetic (the production smoke lane) so its
 * traffic can be filtered out of production diagnostics instead of competing
 * with real user reports.
 *
 * This lives apart from `sentry.ts` on purpose. Playwright specs run in Node
 * with no Vite compilation, so importing anything that reads `import.meta.env`
 * at module scope throws before a test starts. Keeping the shared key here lets
 * the test support module import it directly rather than duplicating the string
 * and silently drifting out of sync.
 */
export const syntheticSessionStorageKey = 'forma:syntheticSession';

/**
 * Reading `localStorage` throws outright in some privacy modes, so this must
 * never be the reason Sentry fails to initialise.
 */
export function readSyntheticSessionFlag(): boolean {
  try {
    return (
      typeof localStorage !== 'undefined' &&
      localStorage.getItem(syntheticSessionStorageKey) === 'true'
    );
  } catch {
    return false;
  }
}
